<template>
  <pt-insure-info class="pt-insure-info__page"></pt-insure-info>
</template>

<script>
import PtInsureInfo from 'cps/insurance-claims/pt-insure-info/withData'
export default {
  name: 'pt-insure-info__view',
  components: {
    'pt-insure-info': PtInsureInfo
  }
}
</script>
